/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_SavedInputs */

const vi_shop_tier_saved = /** @type {(inputs: Shop_Tier_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu hạng thành viên.`)
};

/**

* @param {Shop_Tier_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_saved = /** @type {((inputs?: Shop_Tier_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_saved(inputs)
});